import api from '@/services/utils/base';
import { AxiosPromise } from 'axios';


export default class CampaignNote {
  postCreate(campaignId: string, payload: Bemob.Note): AxiosPromise<Bemob.Response<Bemob.Note>> {
    return api.post(`campaigns/${campaignId}/notes`, payload);
  }


  getList(campaignId: string, payload: Bemob.NoteFilter): AxiosPromise<Bemob.Response<Bemob.Note[]>> {
    let data = {
      params: payload
    };

    return api.get(`campaigns/${campaignId}/notes`, data);
  }

  putUpdate(campaignId: string, id: string, payload: Bemob.Note): AxiosPromise<Bemob.Response<Bemob.Note>> {
    return api.put(`campaigns/${campaignId}/notes/${id}`, payload);
  }
}
